module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"msg":["Company","Value","Volume","Price","Price Change"]},"ar":{"msg":["الشركة","القيمة","الحجم","السعر","التغير في السعر"]}}')
  delete Component.options._Ctor
}
